import "back/wsp/widgets/search/itemCrit";
import {DOM, JSX} from "lib/commons/xml/dom";
import {REG} from "lib/commons/registry";
import {ISearchCrit, SearchItemSgnRegexp, SearchLifeCycleStates, SearchTasksAll, SearchTasksByUsers, SearchTasksDeadline, SearchTasksScheduled} from "lib/wsp/search";
import {OUiCritInit, UiCritArea, UiCritBase} from "back/wsp/widgets/search/uiCrit";
import {EActStage} from "lib/wsp/src";
import {EUserAspects} from "lib/core/user";
import {InputUserPanel, OInputUserInit} from "back/core/widgets/inputs";
import {OUserRefInit, UserRef} from "back/core/widgets/userRef";
import {EItemTypeFamily, ETaskFeatures, ItemTypeTask, LC_DEFAULT_NAME, LC_STATE_DEFAULT_KEY, LC_STATE_DEFAULT_NAME} from "lib/wsp/wspMetaUi";
import {InputPeriod, InputPeriodAction} from "back/core/widgets/inputPeriod";
import {ItemCritRespsonsabilities} from "back/wsp/widgets/search/itemCrit";
import {LANG} from "lib/commons/lang";

// Déclaration des criterions génériques pour la recherche d'items 'wsp.crit.tasks'.
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-uicrit-bool:and", 1, "wsp-uicrit-bool:and");
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-uicrit-bool:or", 1, "wsp-uicrit-bool:or");
REG.reg.addSvcToList("wsp.crit.tasks", "and", 1, "and");
REG.reg.addSvcToList("wsp.crit.tasks", "or", 1, "or");
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-uicrit-free", 1, "wsp-uicrit-free");
//REG.reg.addSvcToList("wsp.crit.tasks", "wsp-uicrit-xpath", 1, "wsp-uicrit-xpath");
REG.reg.addSvcToList("wsp.crit.tasks", "exp", 1, "exp");

REG.reg.addSvcToList("wsp.crit.tasks", "wsp-itemcrit-title", 1, "wsp-itemcrit-title");
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-itemcrit-lastmodif", 1, "wsp-itemcrit-lastmodif");

/**
 * Scope de recherche sur tout l'atelier.
 */
export class TaskCritFullWsp extends UiCritBase {

	static AREA = new UiCritArea("wsp-taskcrit-fullwsp")
		.setLabel("Tâches de l'atelier")
		.setCritSgn("scope").setReplacePattern(/\bscope\b/)
		.setGroup("scope")
		.setBuildAbstract(function (this: UiCritArea, xml: Element, ctx: OUiCritInit) {
			const actStages = xml.getAttribute("actStages")?.split(" ");
			const actStagesTitles = [];
			if (actStages?.indexOf("completed") > -1) actStagesTitles.push("close");
			if (actStages?.indexOf("pending") > -1) actStagesTitles.push("en cours");
			if (actStages?.indexOf("forthcoming") > -1) actStagesTitles.push("à venir");
			const stages = actStagesTitles.join(', ');
			// FIXME : periodOp
			return <span class="crit">Tâches de l'atelier ({actStagesTitles.join(', ')})</span>;
		});

	protected _pending: HTMLInputElement;
	protected _completed: HTMLInputElement;
	protected _forthcoming: HTMLInputElement;

	get withStageCompleted(): boolean {return this._completed.checked}

	get withStagePending(): boolean {return this._pending.checked}

	get withStageForthcoming(): boolean {return this._forthcoming.checked}

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const wsp = this.reg.env.wsp;
		const sr = this.shadowRoot;
		sr.appendChild(<div class="critHead">
			<span class="critTitle">Tâches de l'atelier</span>
			{this.insertAlternativesBtn(init)}
		</div>);
		let optsRoot = sr.appendChild(<div class="h"/>) as HTMLDivElement;
		this._pending = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked onclick={this.onChange}/>en cours</label>).firstElementChild as HTMLInputElement;
		this._completed = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange}/>closes</label>).firstElementChild as HTMLInputElement;
		this._forthcoming = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked onclick={this.onChange}/>à venir</label>).firstElementChild as HTMLInputElement;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		const actStages = xml.getAttribute("actStages")?.split(" ");
		this._pending.checked = actStages?.indexOf("pending") > -1;
		this._completed.checked = actStages?.indexOf("completed") > -1;
		this._forthcoming.checked = actStages?.indexOf("forthcoming") > -1;
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const stages: EActStage[] = [];
		if (this.withStagePending) stages.push("pending");
		if (this.withStageCompleted) stages.push("completed");
		if (this.withStageForthcoming) stages.push("forthcoming");
		return new SearchTasksAll(stages);
	}

	buildUiXmlCrit(): Element | undefined {
		const crit = this.buildCrit().toDom();
		crit.setAttribute("uiCrit", this.getUiCritXmlAtt());
		return crit;
	}
}
customElements.define("wsp-taskcrit-fullwsp", TaskCritFullWsp);
REG.reg.registerSvc("wsp-taskcrit-fullwsp", 1, TaskCritFullWsp.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-fullwsp", 1, "wsp-taskcrit-fullwsp");


/**
 * Scope de recherche pour des users donnés
 */
export class TaskCritByUsers extends UiCritBase {

	static AREA = new UiCritArea("wsp-taskcrit-byusers")
		.setLabel("Tâches des utilisateurs")
		.setGroup("scope")
		.setCritSgn("scope").setReplacePattern(/\bscope\b/)
		.setBuildAbstract(function (this: UiCritArea, xml: Element, ctx: OUiCritInit) {
			// - actStages
			const actStages = xml.getAttribute("actStages")?.split(" ");
			const actStagesTitles = [];
			if (actStages.indexOf("completed") > -1) actStagesTitles.push("close");
			if (actStages.indexOf("pending") > -1) actStagesTitles.push("en cours");
			if (actStages.indexOf("forthcoming") > -1) actStagesTitles.push("à venir");
			const stages = actStagesTitles.join(', ');
			// users
			let usersListVal: HTMLElement;
			const users = xml.getAttribute("users");
			if (users) {
				const accounts = users.split(" ");
				const usersObj = <span/>;
				accounts.forEach((account, pos) => {
					if (pos > 0)
						usersObj.appendChild(<span> ou </span>);
					usersObj.appendChild(<UserRef class="inline list" î={{reg: ctx.reg, nickOrAccount: account, withIcon: false} as OUserRefInit}/>)
				});
				usersListVal = <span>'{usersObj}'</span>;

				const expandUsers = xml.getAttribute("expandUsers")?.split(" ");
				if (expandUsers?.indexOf("toGroups") && expandUsers.indexOf("toMembers"))
					usersListVal.appendChild(<span> (étendu aux membres/groupes)</span>);
				if (expandUsers?.indexOf("toGroups"))
					usersListVal.appendChild(<span> (étendu aux groupes)</span>);
				if (expandUsers?.indexOf("toMembers"))
					usersListVal.appendChild(<span> (étendu aux membres)</span>);
			}
			// Resps
			const modelResps = ctx.reg.env.wsp.wspMetaUi.listResps('task');
			const respsArr = xml.getAttribute("responsibilities")?.split(" ");
			const respsLabels: string[] = [];
			if (respsArr) respsArr.forEach((resp) => {
				const currentResp = modelResps.find((entry) => entry.code === resp);
				respsLabels.push(currentResp ? currentResp.name : resp);
			});
			let respsVal: HTMLElement;

			if (respsLabels.length == 1) {
				const resp = respsLabels[0];
				respsVal = <span>{`(ayant la responsabilité '${resp}')`}</span>;
			} else if (respsLabels.length > 1) {
				const resps = respsLabels.join(" ou ");
				respsVal = <span>{`(ayant l'une des responsabilités '${resps}')`}</span>;
			}

			// FIXME : l10n
			return <span class="crit">Tâches des utilisateurs {usersListVal} {respsVal} dans l'un des états '{actStagesTitles.join(', ')}'</span>;
		});

	protected _userElt: InputUserPanel<any>;
	protected _toGroupsElt: HTMLInputElement;
	protected _toMembersElt: HTMLInputElement;

	protected _pending: HTMLInputElement;
	protected _completed: HTMLInputElement;
	protected _forthcoming: HTMLInputElement;

	protected _respElt: HTMLSelectElement;

	get withStageCompleted(): boolean {return this._completed.checked}

	get withStagePending(): boolean {return this._pending.checked}

	get withStageForthcoming(): boolean {return this._forthcoming.checked}

	get withExpandUsersToGroups(): boolean {return this._toGroupsElt?.checked}

	get withExpandUsersToMembers(): boolean {return this._toMembersElt?.checked}

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;

		const withGroups = this.reg.env.universe.useUsers.hasAspect(EUserAspects.groupable);

		// users
		this._userElt = new InputUserPanel().initialize({
			name: "choiceUser",
			reg: this.reg,
			emptySelectionMsg: withGroups ? "Utilisateurs/groupes..." : "Utilisateurs...",
			userCard: "multi",
			usersGridInit: {
				usersSrv: this.reg.env.universe.useUsers,
				filterTypeInputVisibility: true,
				filterType: null,
			},
		} as OInputUserInit<any>) as InputUserPanel<any>;
		this._userElt.addEventListener("change", this.onChange);

		let critGroups;
		if (withGroups) {
			this._toGroupsElt = <input type="checkbox" onclick={this.onChange}/> as HTMLInputElement;
			this._toMembersElt = <input type="checkbox" onclick={this.onChange}/> as HTMLInputElement;
			critGroups = <div class="h">
				<label class="opt" title="Inclure les items associés aux groupes auxquels les utilisateurs sélectionnés appartiennent">{this._toGroupsElt}+ groupes</label>
				<label class="opt" title="Inclure les items associés aux membres des groupes sélectionnés">{this._toMembersElt}+ membres</label>
			</div>;
		}

		sr.appendChild(<div class="critHead">
			<span class="critTitle">Tâches des utilisateurs</span>
			<div class="inputsCtn">
				{this._userElt}
				{critGroups}
			</div>
			{this.insertAlternativesBtn(init)}
		</div>);

		// actStage
		let optsRoot = sr.appendChild(<div class="h"/>) as HTMLDivElement;
		this._pending = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked onclick={this.onChange}/>en cours</label>).firstElementChild as HTMLInputElement;
		this._completed = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange}/>closes</label>).firstElementChild as HTMLInputElement;
		this._forthcoming = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked onclick={this.onChange}/>à venir</label>).firstElementChild as HTMLInputElement;

		// resp
		/* non implémenter coté java : eu.scenari.wspodb.search.execexp.TasksByUsersExecExp.filterResps
				Crirère dédié utilisé
		this._respElt = <select onchange={this.onChange} class="respSelect" multiple="true"/> as HTMLSelectElement;
		this.reg.env.wsp.wspMetaUi.hasForthcomingTasks()
		const resps = this.reg.env.wsp.wspMetaUi.listResps('task');
		resps?.forEach((resp) => {
			let opt = this._respElt.appendChild(<option value={resp.code}>{resp.name}</option>);
			if(resp.desc) opt.title = resp.desc;
		});
		sr.appendChild(
			<div class="h">
				<div class="v usersBox">
					<span>Responsabilité</span>
					{this._respElt}
				</div>
			</div>
		);
		 */
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		// users
		const users = xml.getAttribute("users")?.split(" ");
		this._userElt.value = users;
		const expandUsers = xml.getAttribute("expandUsers")?.split(" ");
		this._toGroupsElt.checked = expandUsers?.indexOf("toGroups") > -1;
		this._toMembersElt.checked = expandUsers?.indexOf("toMembers") > -1;

		// actStages
		const actStages = xml.getAttribute("actStages")?.split(" ");
		this._pending.checked = actStages?.indexOf("pending") > -1;
		this._completed.checked = actStages?.indexOf("completed") > -1;
		this._forthcoming.checked = actStages?.indexOf("forthcoming") > -1;

		// resps
		const responsibilities = xml.getAttribute("responsibilities")?.split(" ");
		if (responsibilities && this._respElt) {
			for (const opt of this._respElt.options)
				opt.selected = responsibilities.includes(opt.value)

		}
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		// actStages
		const stages: EActStage[] = [];
		if (this.withStagePending) stages.push("pending");
		if (this.withStageCompleted) stages.push("completed");
		if (this.withStageForthcoming) stages.push("forthcoming");
		// resps
		const resps = [];
		if (this._respElt)
			for (const opt of this._respElt.options)
				resps.push(opt.value)

		const crit = new SearchTasksByUsers(this._userElt.value, stages)
			.setExpandToMembers(this._toMembersElt?.checked)
			.setExpandToGroups(this._toGroupsElt?.checked)
			.setResps(resps);
		return crit || new SearchTasksAll(stages);
	}

}

customElements.define("wsp-taskcrit-byusers", TaskCritByUsers);
REG.reg.registerSvc("wsp-taskcrit-byusers", 1, TaskCritByUsers.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-byusers", 1, "wsp-taskcrit-byusers");


/**
 * Scope de recherche pour des le user courant
 */
export class TaskCritForMe extends UiCritBase {

	static AREA = new UiCritArea("wsp-taskcrit-forme")
		.setLabel("Mes tâches")
		.setGroup("scope")
		.setCritSgn("scope").setReplacePattern(/\bscope\b/)
		.setBuildAbstract(function (this: UiCritArea, xml: Element, ctx: OUiCritInit) {
			// - actStages
			const actStages = xml.getAttribute("actStages")?.split(" ");
			const actStagesTitles = [];
			if (actStages.indexOf("completed") > -1) actStagesTitles.push("close");
			if (actStages.indexOf("pending") > -1) actStagesTitles.push("en cours");
			if (actStages.indexOf("forthcoming") > -1) actStagesTitles.push("à venir");
			const stages = actStagesTitles.join(', ');

			// FIXME : l10n
			return <span class="crit">Mes tâches dans l'un des états '{actStagesTitles.join(', ')}'</span>;
		});

	protected _pending: HTMLInputElement;
	protected _completed: HTMLInputElement;
	protected _forthcoming: HTMLInputElement;

	get withStageCompleted(): boolean {return this._completed.checked}

	get withStagePending(): boolean {return this._pending.checked}

	get withStageForthcoming(): boolean {return this._forthcoming.checked}

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;

		sr.appendChild(<div class="critHead">
			<span class="critTitle">Mes tâches</span>
			{this.insertAlternativesBtn(init)}
		</div>);

		// actStage
		let optsRoot = sr.appendChild(<div class="h"/>) as HTMLDivElement;
		this._pending = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked onclick={this.onChange}/>en cours</label>).firstElementChild as HTMLInputElement;
		this._completed = optsRoot.appendChild(<label class="opt"><input type="checkbox" onclick={this.onChange}/>closes</label>).firstElementChild as HTMLInputElement;
		this._forthcoming = optsRoot.appendChild(<label class="opt"><input type="checkbox" checked onclick={this.onChange}/>à venir</label>).firstElementChild as HTMLInputElement;
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		// actStages
		const actStages = xml.getAttribute("actStages")?.split(" ");
		this._pending.checked = actStages?.indexOf("pending") > -1;
		this._completed.checked = actStages?.indexOf("completed") > -1;
		this._forthcoming.checked = actStages?.indexOf("forthcoming") > -1;
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		const stages: EActStage[] = [];
		if (this.withStagePending) stages.push("pending");
		if (this.withStageCompleted) stages.push("completed");
		if (this.withStageForthcoming) stages.push("forthcoming");

		const auth = this.reg.env.universe.auth;
		if (auth.config.noAuthentication || !auth.currentAuthenticatedUser) return new SearchTasksAll(stages);
		return new SearchTasksByUsers([auth.currentAuthenticatedUser.account], stages).setExpandToGroups(true) || new SearchTasksAll(stages);
	}

}

customElements.define("wsp-taskcrit-forme", TaskCritForMe);
REG.reg.registerSvc("wsp-taskcrit-forme", 1, TaskCritForMe.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-forme", 1, "wsp-taskcrit-forme");

/**
 * Type de la tache
 *    <wsp-taskcrit-type/>
 */
export class TaskCritType extends UiCritBase {

	static AREA = new UiCritArea("wsp-taskcrit-type").setLabel("Type")
		.setCritSgn("type").setGroup("task").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const itModels = xml ? xml.getAttribute('uiItModels') : null;
			const itLabels: string[] = [];
			if (itModels != null) {
				const itTypesArray = itModels.split("|");
				itTypesArray.forEach(itModel => {
					itLabels.push(ctx.reg.env.wsp.wspMetaUi.getItemType(itModel).getTitle());
				});
			}
			if (itLabels.length == 1) {
				const itLabel = <span class="critVal">{itLabels[0]}</span>;
				return <span class="crit">Type '{itLabel}'</span>;
			} else if (itLabels.length < 5) {
				return <span class="crit">Types '{itLabels.join(', ')}'</span>;
			} else {
				const itCount = <span class="critVal">{itLabels.length}</span>;
				return <span class="crit" title={itLabels.join(", ")}>{itCount} types</span>;
			}
		});

	protected _typesElt: HTMLSelectElement;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		const it = this.reg.env.wsp.wspMetaUi.getItemTypes();

		this._typesElt = <select onchange={this.onChange} multiple="true"/> as HTMLSelectElement;
		it.forEach((entry) => {
			if (entry.isFamily(EItemTypeFamily.task)) {
				const opt = this._typesElt.appendChild(<option value={entry.getModel()}>{entry.getTitle()}</option>);
				if (entry.getIcon()) opt.style.backgroundImage = `url("${entry.getIcon()}")`;
			}
		});

		const critHead = sr.appendChild(<div class="critHead">
			<span class="critTitle">Type(s) :</span>
			{this._typesElt}
			{this.insertAlternativesBtn(init)}
		</div>);

	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		this._typesElt.selectedIndex = -1;
		const itModelsArray = xml?.getAttribute('uiItModels')?.split("|") || [];
		for (const opt of this._typesElt.options)
			opt.selected = itModelsArray.indexOf(opt.value) > -1 ? true : false;
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		if (this._typesElt.selectedOptions)
			return new SearchItemSgnRegexp(Array.from(this._typesElt.selectedOptions).map(entry => '@' + LANG.escape4Regexp(entry.value) + "\\b.*"));
	}

	/**
	 *  Critères UI :
	 *    uiItModels : liste des itModels sélectionnés, sépapés par un |
	 */
	buildUiXmlCrit(): Element | undefined {
		const selectedItModels: string[] = [];
		for (const opt of this._typesElt.selectedOptions)
			if (opt.selected) selectedItModels.push(opt.value)
		const crit: Element = super.buildUiXmlCrit();
		if (crit && selectedItModels) crit.setAttribute("uiItModels", selectedItModels.join("|"));
		return crit;
	}

}
customElements.define("wsp-taskcrit-type", TaskCritType);
REG.reg.registerSkin('wsp-taskcrit-type', 1, /* language=CSS */ `
	select {
		/*flex:1;*/
	}

	option {
		/*background-image: url("affecteeDynamiquement");*/
	  background-repeat: no-repeat;
	  background-size: auto 1rem;
	  min-width: 3rem;
	  padding-inline-start: 1.3rem;
  }
`);
REG.reg.registerSvc("wsp-taskcrit-type", 1, TaskCritType.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-type", 1, "wsp-taskcrit-type");

/**
 * Deadline de la tache
 *    <wsp-taskcrit-deadline/>
 */
export class TaskCritDeadline extends UiCritBase {

	static AREA = new UiCritArea("wsp-taskcrit-deadline")
		.setLabel("Date limite").setReplacePattern(/\bdate\b/).setGroup("task")
		.setVisible((ctx) => {
			const wspMetaUi = ctx.reg.env.wsp.wspMetaUi;
			const tasksIt: ItemTypeTask[] = wspMetaUi.getItemTypes().filter((entry) => entry.isFamily(EItemTypeFamily.task)) as ItemTypeTask[];
			return tasksIt?.find(entry => entry.hasFeature(ETaskFeatures.deadline)) ? true : false;
		})
		.setCritSgn("type").setGroup("task").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			//FIXME : afficher une forme lisible de la date spécifiée
			const modes = InputPeriod.buildDefaultModes_futurAndPast();
			const uiCurrentModeId = xml?.getAttribute("uiCurrentMode");
			const uiCurrentMode: InputPeriodAction = uiCurrentModeId ? modes.find((entry) => entry.getId() === uiCurrentModeId) as InputPeriodAction : null;
			const uiCurrentModeLabel = uiCurrentMode?.selectedLabel || uiCurrentMode?.getLabel(null);
			return uiCurrentModeLabel ? <span class="crit"><span class="critTitle">Date limite de type</span> '<span class="critVal">{uiCurrentModeLabel}</span>'</span> : <span class="crit"><span class="critTitle">Date limite</span></span>;
		});

	protected _dateElt: InputPeriod;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this._dateElt = new InputPeriod().initialize({defaultLabel: "Choisir une valeur...", modes: InputPeriod.buildDefaultModes_futurAndPast()});
		this._dateElt.addEventListener("change", this.onChange);
		this._dateElt.addEventListener("input", this.onChange);
		const icon = this.critArea ? this.critArea.getIcon({reg: this.reg}) : null;
		const img = icon ? <img src={icon}/> : null;
		const head = sr.appendChild(<div class="critHead">
			{img}
			<span class="critTitle">{this.critArea ? this.critArea.getLabel({reg: this.reg}) : ""}</span>
			{this._dateElt}
			{this.insertAlternativesBtn(init)}
		</div>);
		UiCritBase.initHeadFromArea(this.critArea, {reg: this.reg}, head);
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		this._dateElt.reset(xml.getAttribute("uiCurrentMode"), xml.hasAttribute("uiCurrentLess") ? Number.parseInt(xml.getAttribute("uiCurrentLess")) : null, xml.hasAttribute("uiCurrentMore") ? Number.parseInt(xml.getAttribute("uiCurrentMore")) : null);
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		if (this._dateElt.isSpecified())
			return SearchTasksDeadline.buildFromInputPeriod(this._dateElt);
		return undefined;
	}

	/**
	 *  Critères UI :
	 *    uiCurrentMode, uiCurrentLess, uiCurrentMore
	 */
	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit) {
			if (crit && this._dateElt.isSpecified()) {
				crit.setAttribute("uiCurrentMode", this._dateElt.currentMode.getId());
				// Valeurs brutes (sans les regles d'exclusion/normalisation qui sont fournies par le "currentMode")
				if (this._dateElt.date1.valueAsNumber) crit.setAttribute("uiCurrentLess", this._dateElt.date1.valueAsNumber.toString());
				if (this._dateElt.date2.valueAsNumber) crit.setAttribute("uiCurrentMore", this._dateElt.date2.valueAsNumber.toString());
			}
		}
		return crit;
	}

}
customElements.define("wsp-taskcrit-deadline", TaskCritDeadline);
REG.reg.registerSvc("wsp-taskcrit-deadline", 1, TaskCritDeadline.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-deadline", 1, "wsp-taskcrit-deadline");

/**
 * Deadline de la tache
 *    <wsp-taskcrit-scheduled/>
 */
export class TaskCritScheduled extends TaskCritDeadline {

	static AREA = new UiCritArea("wsp-taskcrit-scheduled")
		.setLabel("Date de planification").setReplacePattern(/\bdate\b/).setGroup("task")
		.setVisible((ctx) => {
			const wspMetaUi = ctx.reg.env.wsp.wspMetaUi;
			const tasksIt: ItemTypeTask[] = wspMetaUi.getItemTypes().filter((entry) => entry.isFamily(EItemTypeFamily.task)) as ItemTypeTask[];
			return tasksIt?.find(entry => entry.hasFeature(ETaskFeatures.scheduling)) ? true : false;
		})
		.setCritSgn("type").setGroup("task").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			//FIXME : afficher une forme lisible de la date spécifiée
			const modes = InputPeriod.buildDefaultModes_futurAndPast();
			const uiCurrentModeId = xml?.getAttribute("uiCurrentMode");
			const uiCurrentMode: InputPeriodAction = uiCurrentModeId ? modes.find((entry) => entry.getId() === uiCurrentModeId) as InputPeriodAction : null;
			const uiCurrentModeLabel = uiCurrentMode?.selectedLabel || uiCurrentMode?.getLabel(null);
			return uiCurrentModeLabel ? <span class="crit"><span class="critTitle">Date de planification de type</span> '<span class="critVal">{uiCurrentModeLabel}</span>'</span> :
				<span class="crit"><span class="critTitle">Date de planification</span></span>;
		});

	buildCrit(): ISearchCrit | undefined {
		if (this._dateElt.isSpecified())
			return SearchTasksScheduled.buildFromInputPeriod(this._dateElt);
		return undefined;
	}
}

customElements.define("wsp-taskcrit-scheduled", TaskCritScheduled);
REG.reg.registerSvc("wsp-taskcrit-scheduled", 1, TaskCritScheduled.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-scheduled", 1, "wsp-taskcrit-scheduled");

/**
 * Cycle de vie de la tache
 *    <wsp-taskcrit-lifecycle/>
 */
export class TaskCritLifeCycle extends UiCritBase {

	static AREA = new UiCritArea("wsp-taskcrit-lifecycle")
		.setLabel((ctx) => ctx.reg.env.wsp.wspMetaUi.getLcName())
		.setVisible((ctx) => {
			const wspMetaUi = ctx.reg.env.wsp.wspMetaUi;
			const tasksIt: ItemTypeTask[] = wspMetaUi.getItemTypes().filter((entry) => entry.isFamily(EItemTypeFamily.task)) as ItemTypeTask[];
			return tasksIt?.find(entry => entry.getLcStates()?.size) ? true : false;
		})
		.setCritSgn("lifecycle").setGroup("task").setBuildAbstract((xml: Element, ctx: OUiCritInit): HTMLElement => {
			const lcName = LC_DEFAULT_NAME;
			const uiCritStatesByModelsStr = xml.getAttribute("uiCritStatesByModels");
			if (uiCritStatesByModelsStr && uiCritStatesByModelsStr.length) {
				const wspMetaUi = ctx.reg.env.wsp.wspMetaUi;
				const uiCritStatesByModels = uiCritStatesByModelsStr.split(" ");

				function makeLcLabelEntry(itModel: string, lcCode: string): string {
					const it = wspMetaUi.getItemType(itModel) as ItemTypeTask;
					const lc = it?.getLcStateOrUnknown(lcCode);
					return lc.name || lcCode;
				}

				if (uiCritStatesByModels.length == 1) {
					const args = uiCritStatesByModels[0].split(":");
					<span class="crit">État du {lcName} : <span class="critVal">{makeLcLabelEntry(args[0], args[1])}</span></span>
				} else {
					const vals = new Set<string>();
					uiCritStatesByModels.forEach((entry) => {
						const args = entry.split(":");
						vals.add(makeLcLabelEntry(args[0], args[1]));
					});
					return <span class="crit">États du {lcName} : <span class="critVal">{Array.from(vals).sort().join(", ")}</span></span>
				}
			} else {
				const lcStates = xml.getAttribute("lcStates") || "";
				const lcStatesArr = lcStates.split(" ");
				const lcStatesLabels = lcStatesArr.join(", ");
				return <span class="crit">État(s) du {lcName} : <span class="critVal">{lcStatesLabels}</span></span>;
			}
		});

	protected _lcElt: HTMLSelectElement;

	protected _initialize(init: OUiCritInit): void {
		super._initialize(init);
		const sr = this.shadowRoot;
		this.reg.installSkin("wsp-taskcrit-lifecycle", sr);

		this._lcElt = <select onchange={this.onChange} class="lcSelect" multiple="true"/> as HTMLSelectElement;

		const wspMetaUi = this.reg.env.wsp.wspMetaUi;
		const tasksIt: ItemTypeTask[] = wspMetaUi.getItemTypes().filter((entry) => entry.isFamily(EItemTypeFamily.task)) as ItemTypeTask[];
		tasksIt.forEach((it) => {
			const lcs = it.getLcStates();
			if (lcs.size) {
				let optFrp = this._lcElt.appendChild(this._lcElt.appendChild(<optgroup label={it.getTitle()}/>));
				lcs.forEach((lc) => {
					let opt = optFrp.appendChild(<option value={lc.code || LC_STATE_DEFAULT_KEY} data-model={it.getModel()}>{lc.name || LC_STATE_DEFAULT_NAME}</option>);
					opt.style.color = lc.color || "var(--color)";
					if (lc.iconUrl) opt.style.backgroundImage = `url("${lc.iconUrl}")`;
					if (lc.code == "") DOM.setAttrBool(opt, "selected", true);
				});

			}
		});

		const critHead = sr.appendChild(<div class="critHead">
			<div class="h">
				<span class="critTitle">{this.reg.env.wsp.wspMetaUi.getLcName()}</span>
				{this._lcElt}
			</div>
			{this.insertAlternativesBtn(init)}
		</div>);
	}

	async initFromXmlCrit(xml: Element): Promise<this> {
		// LC
		this._lcElt.selectedIndex = -1;
		const lcStates = xml.getAttribute("lcStates") || "";
		const lcStatesArr = lcStates.split(" ");
		Array.from(this._lcElt.options).forEach(opt => {
			opt.selected = lcStatesArr.includes(opt.value)
		})
		return this;
	}

	buildCrit(): ISearchCrit | undefined {
		let crit = new SearchLifeCycleStates();
		crit.lcStates = [];
		Array.from(this._lcElt.selectedOptions).forEach(opt => crit.lcStates.push(opt.value));
		return crit;
	}

	buildUiXmlCrit(): Element | undefined {
		const crit: Element = super.buildUiXmlCrit();
		if (crit) {
			const statesWithModel: string[] = [];
			Array.from(this._lcElt.selectedOptions).forEach(opt => statesWithModel.push(opt.getAttribute('data-model') + ":" + opt.value));
			crit.setAttribute("uiCritStatesByModels", statesWithModel.join(" "));
		}
		return crit;
	}

}

customElements.define("wsp-taskcrit-lifecycle", TaskCritLifeCycle);
REG.reg.registerSkin('wsp-taskcrit-lifecycle', 1, /* language=CSS */ `
	select {
		flex: 1;
		resize: vertical;
		height: 10rem;
	}

	option {
		/*background-image: url("affecteeDynamiquement");*/
		background-repeat: no-repeat;
		background-size: auto 1rem;
		min-width: 3rem;
		padding-inline-start: 1.3rem;
	  margin-inline-start: 1.3rem;
  }

  option::before {
	  content: "" !important;
  }

`);
REG.reg.registerSvc("wsp-taskcrit-lifecycle", 1, TaskCritLifeCycle.AREA);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-lifecycle", 1, "wsp-taskcrit-lifecycle");

/**
 * Resps
 */
class ItemCritRespsonsabilities_task extends ItemCritRespsonsabilities {
	protected target: 'task' | 'item' = "task";
}

customElements.define("wsp-taskcrit-respsonsabilities", ItemCritRespsonsabilities_task);
REG.reg.registerSvc("wsp-taskcrit-respsonsabilities", 1, ItemCritRespsonsabilities.AREA_task);
REG.reg.addSvcToList("wsp.crit.tasks", "wsp-taskcrit-respsonsabilities", 1, "wsp-taskcrit-respsonsabilities");